import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { BanknoteIcon, BellIcon, CalendarDaysIcon, CalendarRangeIcon, ClipboardCheckIcon, FolderOpenIcon, LayoutDashboardIcon, LogOutIcon, MenuIcon, SettingsIcon, UsersIcon, XIcon } from 'lucide-react';
import { useApp } from '../../contexts/AppContext';
import { Logo } from '../ui/Logo';
import { Avatar } from '../ui/Avatar';
import { Toasts } from '../ui/Toasts';
import { functionLabel } from '../../utils/labels';
const nav = [{
  to: '/admin',
  label: 'Nadzorna plošča',
  icon: LayoutDashboardIcon,
  end: true
}, {
  to: '/admin/clani',
  label: 'Člani',
  icon: UsersIcon,
  end: false
}, {
  to: '/admin/dogodki',
  label: 'Dogodki',
  icon: CalendarDaysIcon,
  end: false
}, {
  to: '/admin/prisotnost',
  label: 'Prisotnost',
  icon: ClipboardCheckIcon,
  end: false
}, {
  to: '/admin/obvestila',
  label: 'Obvestila',
  icon: BellIcon,
  end: false
}, {
  to: '/admin/clanarine',
  label: 'Članarine',
  icon: BanknoteIcon,
  end: false
}, {
  to: '/admin/gradiva',
  label: 'Gradiva',
  icon: FolderOpenIcon,
  end: false
}, {
  to: '/admin/koledar',
  label: 'Koledar',
  icon: CalendarRangeIcon,
  end: false
}, {
  to: '/admin/nastavitve',
  label: 'Nastavitve',
  icon: SettingsIcon,
  end: false
}];
export function AdminLayout() {
  const {
    currentMember,
    logout,
    settings
  } = useApp();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const sidebar = <div className="flex h-full flex-col bg-green-700" data-id="element-69" data-mp="3gwgpqd2jduqv">
      <div className="flex h-16 items-center gap-3 border-b border-white/10 px-5" data-id="element-70" data-mp="3c0hvw9yfvkj2">
        <Logo variant="dark" className="h-9" data-id="element-71" data-mp="36zu4voa7n3ou" />
        <div className="leading-tight" data-id="element-72" data-mp="36yis4yyselll">
          <p className="text-sm font-semibold text-white" data-id="element-73" data-mp="321iv1djx0t6m">VIVA Portal</p>
          <p className="text-[11px] text-green-100/80" data-id="element-74" data-mp="323daiccf3t3b">Vodstvo zbora</p>
        </div>
      </div>
      <nav aria-label="Administracija" className="flex-1 space-y-0.5 overflow-y-auto viva-scroll p-3" data-id="element-75" data-mp="1vj3vxxeejxrj">
        {nav.map(n => <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} className={({
        isActive
      }) => `flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors duration-150 ease-out ${isActive ? 'bg-white text-green-700' : 'text-green-50/90 hover:bg-white/10 hover:text-white'}`} data-id="element-76" data-mp="imy11gezai5k">
            <n.icon className="h-4 w-4 shrink-0" data-id="element-77" data-mp="3v2iaa4iecjts" />
            {n.label}
          </NavLink>)}
      </nav>
      <div className="border-t border-white/10 p-3" data-id="element-78" data-mp="3rib9nlfl8ez">
        <p className="px-3 pb-2 text-[11px] uppercase tracking-wide text-green-100/70" data-id="element-79" data-mp="3m46frreet1w2">{settings.slogan}</p>
      </div>
    </div>;
  return <div className="flex min-h-full w-full bg-canvas" data-id="element-80" data-mp="3r0dmvnijkjfl">
      <aside className="hidden w-64 shrink-0 lg:block" data-id="element-81" data-mp="3c4xq3aqku9fi">
        <div className="fixed inset-y-0 left-0 w-64" data-id="element-82" data-mp="3c7jw35xtkgvm">{sidebar}</div>
      </aside>

      {open && <div className="fixed inset-0 z-50 lg:hidden" data-id="element-83" data-mp="3h64z1d4ghenr">
          <div className="absolute inset-0 bg-ink/40" onClick={() => setOpen(false)} data-id="element-84" data-mp="2xja2ffl60mrw" />
          <div className="absolute inset-y-0 left-0 w-64" data-id="element-85" data-mp="2thyjfswsqzso">{sidebar}</div>
          <button onClick={() => setOpen(false)} aria-label="Zapri meni" className="absolute right-4 top-4 rounded-lg bg-white p-2 text-ink" data-id="element-86" data-mp="37genfc39yc74">
            <XIcon className="h-4 w-4" data-id="element-87" data-mp="3ghctdzx9wtsc" />
          </button>
        </div>}

      <div className="flex min-w-0 flex-1 flex-col" data-id="element-88" data-mp="3gf05750x9n6u">
        <header className="sticky top-0 z-30 border-b border-line bg-white" data-id="element-89" data-mp="3ceq2c18ffcw7">
          <div className="flex h-16 items-center justify-between gap-4 px-4 sm:px-6" data-id="element-90" data-mp="3q7pd5px9kixf">
            <div className="flex items-center gap-3" data-id="element-91" data-mp="3l8cttf5lptzl">
              <button onClick={() => setOpen(true)} aria-label="Odpri meni" className="rounded-lg p-2 text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas lg:hidden" data-id="element-92" data-mp="3l8mhgw36bp24">
                <MenuIcon className="h-5 w-5" data-id="element-93" data-mp="1sjvfdr3yd6fx" />
              </button>
              <div data-id="element-94" data-mp="1shiub52wefyn">
                <p className="text-sm font-semibold text-ink" data-id="element-95" data-mp="1xif05o6t8c6p">{settings.imeZbora}</p>
                <p className="text-xs text-ink-muted" data-id="element-96" data-mp="1xgc0sdjrp6pb">Sezona 2026/27</p>
              </div>
            </div>
            <div className="flex items-center gap-3" data-id="element-97" data-mp="278i068ccmqej">
              <button onClick={() => navigate('/clan')} className="hidden rounded-lg border border-line px-3 py-1.5 text-[13px] font-medium text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink sm:block" data-id="element-98" data-mp="277yk6x69ec35">
                Pogled člana
              </button>
              {currentMember && <div className="flex items-center gap-2" data-id="element-99" data-mp="1oia2w6vbyu69">
                  <Avatar member={currentMember} size="sm" data-id="element-100" data-mp="1ofnmriudj6cf" />
                  <div className="hidden leading-tight sm:block" data-id="element-101" data-mp="2uxaq9o6ai418">
                    <p className="text-[13px] font-medium text-ink" data-id="element-102" data-mp="2zwnm2yf52lfy">
                      {currentMember.ime} {currentMember.priimek}
                    </p>
                    <p className="text-[11px] text-ink-muted" data-id="element-103" data-mp="obwins11vmxi">
                      {currentMember.functions.map(f => functionLabel[f]).join(', ')}
                    </p>
                  </div>
                </div>}
              <button onClick={() => {
              logout();
              navigate('/');
            }} aria-label="Odjava" className="rounded-lg p-2 text-ink-muted transition-colors duration-150 ease-out hover:bg-canvas hover:text-ink" data-id="element-104" data-mp="9lfkchjppd4u">
                <LogOutIcon className="h-4 w-4" data-id="element-105" data-mp="3rpqyx5uxuhlu" />
              </button>
            </div>
          </div>
        </header>

        <main className="flex-1 px-4 py-6 sm:px-6 lg:px-8" data-id="element-106" data-mp="3msqzhdslgd3p">
          <Outlet data-id="element-107" data-mp="1pzp93crv93w7" />
        </main>
      </div>

      <Toasts data-id="element-108" data-mp="1pynmqc5eguz6" />
    </div>;
}